import Storage from "../helpers/Storage";
import {CHANGE_LANGUAGE, CHANGE_DIRECTION} from '../actions/Lang';

const initialState = {
    language: Storage.getLanguage(),
    direction: Storage.directionGet()
};


const LangReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_LANGUAGE:
            return {...state,
                language: action.payload.language
            };
        case CHANGE_DIRECTION:
            return {...state,
                direction: action.payload.direction
            };
        default:
            return state
    }
};


export default LangReducer;
